import { SVGProps } from 'react';

export const InfoStatusIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="14" cy="13.5117" r="13.5" fill="#5C8FDC" />
            <path
                d="M13.7675 8.44922C14.5085 8.44922 15.035 7.90322 15.035 7.20122C15.035 6.53822 14.489 6.01172 13.7675 6.01172C13.046 6.01172 12.5 6.55772 12.5 7.24022C12.5 7.92272 13.046 8.44922 13.7675 8.44922ZM12.8315 20.7732H14.7035V10.4382H12.8315V20.7732Z"
                fill="white"
            />
        </svg>
    );
};
